<template>
  <div>
    <h3 v-if="showTitle" class="">{{ locationType }} Address</h3>
    <input
            type="text"
            v-model="location.address1"
            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
            placeholder="Address Line 1"
    />
    <input
            type="text"
            v-model="location.address2"
            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
            placeholder="Address Line 2"
    />
    <input
            type="text"
            v-model="location.city"
            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
            placeholder="City"
            required
    />
    <input
            type="text"
            v-model="location.state_province"
            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
            placeholder="State or Province"
            required
    />
    <input
            type="text"
            v-model="location.postal_code"
            class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
            placeholder="Postal Code"
            required
    />
  </div>
</template>
<script>
export default {
    props: {
        locationType: String,
        location: Object,
        showTitle:{
            type:Boolean,
            required:false,
            default:true
        }
    },
    watch:{
        location:{
            handler(newLocation){
                this.$emit('locationUpdated', newLocation);
            },
            deep: true
        }
    }
}
</script>
